export default __webpack_public_path__ + "static/media/element0.9f35667a.svg";